import styled from 'styled-components'

import InputFile from '../../../../../../shared/components/InputFile'
import { colors } from '../../../../../../shared/styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const ContainerPhoto = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  & > label {
    align-self: flex-start;
  }

  & > span {
    align-self: flex-start;
    color: ${colors.blue};

    &:last-child {
      color: ${colors.blueLight};
      font-weight: 700;
    }
  }
`

export const Title = styled.span`
  color: ${colors.green};
  font-weight: 700;
  font-size: 16px;
  padding-top: 30px;
`

export const SubTitle = styled.span`
  color: ${colors.blue};
  font-size: 14px;
`

export const StyledInputFile = styled(InputFile)`
  margin-top: 10px;
`
